module.exports = __webpack_public_path__ + "static/media/ic-alert.2fd92658.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-alert.svg
// module id = 414
// module chunks = 0